<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol >
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                </CCol>
                <CCol
                    class="d-flex justify-content-end"
                >
                    <CButton            
                        class="button shadow create-button"
                        :title="$t('add_tag')"
                        @click="
                            $router.push({
                                name: 'add_tag'
                            })
                        "
                    >
                        <span class="button__icon text-white-50">
                            <CIcon :content="$options.icons.cilPlus"/>
                        </span>            
                        <span class="button__text"> {{ $t("add_tag") }} </span>
                    </CButton>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.tags.items"
                                    :fields="traslateArrayObjects({ 
                                        array:tables.tags.fields,
                                        fields:['label']
                                    })"
                                    :itemsPerPageSelect="{
                                        values:[5, 10, 20],
                                    }"
                                    :columnFilterValue.sync="tables.tags.columnFilterValue"
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.tags.rows"
                                    v-bind="tables.tags"
                                >
                                    <template #id="{ item }" >
                                        <td>
                                            {{ item.id }}
                                        </td>
                                    </template>
                                    <template #file_name="{ item }" >
                                        <td>
                                            <a :href="item.file_url">
                                                {{ (item.file_name) ? item.file_name:'' }}
                                            </a>
                                        </td>
                                    </template>
                                    <template #activity="{ index }">
                                        <td class="text-center">
                                            <CSpinner grow :color="activity[index]" size="sm" />
                                        </td>
                                    </template>
                                    
                                    <template #options="{ item }">
                                        <td class="py-2">
                                            
                                            <CButton
                                                color="primary"
                                                class="mx-1"
                                                square
                                                :title="$t('edit_tag')"
                                                size="sm"
                                                @click="
                                                    $router.push({
                                                        name: 'edit_tag',
                                                        query: { uuid: item.uuid },
                                                    })
                                                "
                                            >
                                                <CIcon class="icon" :content="$options.icons.cilSettings"/>
                                            </CButton>
                                        </td>
                                    </template>
                                    
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.tags.total_pages > 0"
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.tags.page"
                                        :pages="tables.tags.total_pages"
                                        align="center"
                                    />
                                    <CElementCover :opacity="0.8" class="bg-trasparent" v-if="tables.tags.loading"/>
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
  
</template>

<script>
import FilterDate from "~/components/FilterDate";
import { cilPlus, cilSettings, cilReload, cilPencil, cilChart , cilTrash, cilArrowThickFromRight, cilMediaPlay, cilMediaStop } from '@coreui/icons';
import pageMixin from '~/mixins/page.js';
import tableMixin from '~/mixins/table.js';
import TagTable from './config/tables/tags.js';
export default {
    name:"TagsPage",
    middleware: ["auth","page"],
    mixins: [ pageMixin, tableMixin ],
    components:{
        FilterDate
    },
    icons:{
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
        cilReload,
        cilChart,
        cilMediaPlay,
        cilMediaStop
    },
    data(){
        return{
            tables:{
                tags:TagTable
            },
            activity:[],
            intervalActivity:null
        }
    },
    computed:{
        title_page:function(){
            return this.$t("tags");
        }
    },
    methods:{
        itemPerPage(newValue){
            this.tables.tags.rows = newValue;
            this.updatePagination(this.tables.tags.page);
        },
        updatePagination(newValue){
            this.tables.tags.page = newValue;
            this.updateData();
        },
        async updateData(){
            await this.updateTable({
                tableName:"tags", 
                url:'/tags',
                fetch:{
                    baseURL: process.env.VUE_APP_API_CORE,
                },
                adapterFilters: (filters)=>{
                    delete filters.where.created_at
                    return filters;
                }
            });
            this.tables.tags.loading = false;
            this.updatePageLoading(false);
        }
    },
    async mounted(){
        await this.updateData();
    }
}
</script>

<style scoped lang="scss">
    /* .request-report{
        overflow: hidden;
        width: 30%;
    }
    .message{
        width: 30%;
        overflow: hidden;
    } */
    .message__container{
        overflow: hidden;
    }

    .pre{
        & .pre__container{
            max-width: 30rem;
            overflow: auto;
            & .span__pre {
                display: block;
                unicode-bidi: embed;
                font-family: monospace;
                /* white-space: pre; */
                white-space: pre-wrap;
            }
        }
        
    }
    
    
</style>